module.exports = __webpack_public_path__ + "img/cw_banner4.461cf1ad.png";